import TYPE from '../../../../api/types'

import SortableFrontpage from './SortableFrontpage'

import appSetupFormFactory from '../../../factories/appSetupFormFactory'

export default appSetupFormFactory(TYPE.APP_FRONTPAGE, SortableFrontpage)
